export default "__VITE_ASSET__CaPrDP8E__"